import React from 'react';
import { Users, Building, Briefcase } from 'lucide-react';

const CUSTOMER_TYPES_WITH_ICONS = [
  { value: 'domestico', label: 'Domestico', icon: Users },
  { value: 'condominio', label: 'Condominio', icon: Building },
  { value: 'business', label: 'Business', icon: Briefcase },
];

/**
 * Form di configurazione: lead source, tipologia cliente, target risparmio.
 * @param {Object} props
 * @param {Array<{value,label}>} props.leadSources - provenienze lead disponibili (dal DB)
 * @param {string} props.leadSource
 * @param {Function} props.onLeadSourceChange
 * @param {string} props.customerType
 * @param {Function} props.onCustomerTypeChange
 * @param {string} props.targetSavings
 * @param {Function} props.onTargetSavingsChange
 */
export const ConfigForm = ({
  isAdmin = true,
  accountName = '',
  accountRole = 'agent',
  allowedCustomerTypes = null,
  leadSources = [],
  leadSource, onLeadSourceChange,
  customerType, onCustomerTypeChange,
  targetSavings, onTargetSavingsChange,
}) => {
  const nonAdminLabel = accountRole === 'employee' ? 'Sales Executive' : 'Agenzia';
  const visibleTypes = Array.isArray(allowedCustomerTypes)
    ? CUSTOMER_TYPES_WITH_ICONS.filter((t) => allowedCustomerTypes.includes(t.value))
    : CUSTOMER_TYPES_WITH_ICONS;
  return (
    <div className="el-card p-6">
      {isAdmin ? (
        <div className="mb-6">
          <label className="el-label block mb-2">1. Provenienza Lead <span className="text-red-500">*</span></label>
          <select
            value={leadSource}
            onChange={(e) => onLeadSourceChange(e.target.value)}
            className="el-input w-full"
            data-testid="lead-source-select"
          >
            <option value="">Seleziona provenienza...</option>
            {leadSources.map((source) => (
              <option key={source.value} value={source.value}>{source.label}</option>
            ))}
          </select>
        </div>
      ) : (
        <div className="mb-6">
          <label className="el-label block mb-2">1. {nonAdminLabel}</label>
          <div
            className="el-input w-full bg-[#F4F7F4] text-[#1B291B] flex items-center font-medium"
            data-testid="provenance-fixed"
          >
            {accountName || '—'}
          </div>
        </div>
      )}

      <h3 className="el-label mb-3">2. Tipologia Cliente <span className="text-red-500">*</span></h3>
      <div className={`grid gap-3 ${visibleTypes.length === 1 ? 'grid-cols-1' : visibleTypes.length === 2 ? 'grid-cols-2' : 'grid-cols-3'}`}>
        {visibleTypes.map((type) => (
          <button
            key={type.value}
            onClick={() => onCustomerTypeChange(type.value)}
            className={`p-4 rounded-xl border-2 transition-all ${
              customerType === type.value
                ? 'border-[#4CAF50] bg-[#E8F5E9]'
                : 'border-[#DCE3DC] hover:border-[#4CAF50]/50'
            }`}
            data-testid={`customer-type-${type.value}`}
          >
            <type.icon className={`w-6 h-6 mx-auto mb-2 ${customerType === type.value ? 'text-[#4CAF50]' : 'text-[#5C6E5C]'}`} />
            <span className={`text-sm font-medium ${customerType === type.value ? 'text-[#1B291B]' : 'text-[#5C6E5C]'}`}>
              {type.label}
            </span>
          </button>
        ))}
      </div>

      <div className="mt-4">
        <label className="el-label block mb-2">3. % Risparmio Target <span className="text-red-500">*</span></label>
        <input
          type="number"
          value={targetSavings}
          onChange={(e) => onTargetSavingsChange(e.target.value)}
          className="el-input w-full"
          placeholder="es. 10"
          min="0" max="100" step="0.1"
          data-testid="target-savings-input"
        />
      </div>
    </div>
  );
};
